import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-cream" data-id="element-133" data-mp="128fnvds7g3t2">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-134" data-mp="xa4ibf8y0fgn">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-135" data-mp="sb1efy4p8fa9">
          <div className="inline-block px-3 py-1 rounded-full border border-leaf bg-lime-soft text-forest font-bold text-xs sm:text-sm tracking-widest whitespace-nowrap mb-4 sm:mb-6" data-id="element-136" data-mp="3d1a4za4glt8j">
            HYDROPONICS GROWER READY
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-forest uppercase" data-id="element-137" data-mp="3j9tymsm91cin">
            Everything You Need to <span className="text-leaf" data-id="element-138" data-mp="39b4gcyqfxq1v">Build, Grow & Harvest</span> Your
            Hydroponic Garden — <span className="text-leaf" data-id="element-139" data-mp="3e8wi0kgw0qj9">Just One Click Away</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-140" data-mp="30hrgtdxvfq6t">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-141" data-mp="2viomanfip2d3" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-142" data-mp="2hlj7nz1qmv68">
          <p className="text-sm sm:text-lg md:text-xl text-charcoal leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-143" data-mp="nbbcixheu94r">
            The Complete{' '}
            <span className="font-semibold text-forest" data-id="element-144" data-mp="id9r45wihxq4">6-in-1 Visual Growing System</span> with{' '}
            <span className="font-semibold text-forest" data-id="element-145" data-mp="degf6hwvies2">6 Complete Volumes</span> + 5 Practical
            Grower Bonuses — Created to Help You Build, Grow, Troubleshoot & Harvest From Home.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-leaf mb-5 sm:mb-7" data-id="element-146" data-mp="163454qskhsby">
            100% VISUAL · BEGINNER FRIENDLY · FROM SETUP TO HARVEST
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-147" data-mp="x1w6g7m52phc">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-148" data-mp="x3h6gcr830ml">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-charcoal/80 mb-3" data-id="element-149" data-mp="1xam4cnf59kxc">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-150" data-mp="269hdo8dhjb4v">
                <CheckCircle size={14} className="text-leaf" data-id="element-151" data-mp="2686aoarv67et" />
                <span className="font-medium" data-id="element-152" data-mp="2b1hj2gcbqw8u">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-charcoal/60" data-id="element-153" data-mp="2fzanb3u2hg6h">
            6 Complete Volumes · 100% Visual Growing System · 5 Practical Bonus Resources
          </p>
        </motion.div>
      </div>
    </section>;
}